import React from 'react';
import { NavLink } from 'react-router-dom';

function Footer() {
  return (
    <>
      <footer className="bg-slate-900 text-white py-7 border-t border-gray-700 mt-8 pt-5 text-center text-gray-400 text-sm">
        <div className="max-w-screen-xl mx-auto px-5 flex flex-col md:flex-row items-center md:items-start justify-between text-center md:text-left">
          {/* Brand & Tagline */}
          <div className="md:w-2/3 w-full mb-6 md:mb-0 md:text-left">
            <h4 className="text-3xl font-bold">KnowQuest</h4>
            <p className="text-gray-400 mt-2 text-sm md:text-base">
              Disrupting Feedback & Building Trust
            </p>
          </div>

          <div className="md:w-1/3 w-full  flex justify-evenly">
            {/* Navigation Links */}
            <div className="md:w-3/6  text-center md:text-left mt-4 md:mt-0">
              <h5 className="text-lg font-semibold mb-3">About</h5>
              <ul className="space-y-1 text-gray-400 text-sm md:text-sm">
                <li>
                  <NavLink to="/about" className="hover:text-white">
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" className="hover:text-white">
                    Contact Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/howitworks" className="hover:text-white">
                    How It Works
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/terms" className="hover:text-white">
                    Terms & Conditions
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/privacy" className="hover:text-white">
                    Privacy Policy
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Social Links */}
            <div className="md:w-3/6 text-center md:text-left mt-4 md:mt-0">
              <h5 className="text-lg font-semibold mb-3">Follow Us</h5>
              <div className="flex justify-center md:justify-start">
                <a
                  href="https://www.facebook.com/KnowQuestinc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white text-sm md:text-sm"
                >
                  Facebook
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Copyright Section */}
        <div className="border-t border-gray-700 mt-8 pt-5 text-center text-gray-400 text-sm">
          Copyright 2025 © KnowQuest Inc. All rights reserved
        </div>
      </footer>
    </>
  );
}

export default Footer;
